<div class="paddingScreen py-3">
    <form class="login-form registration-form report-issue-form" [formGroup]="reportIssueForm">
        <div class="row login pt-4">
            <ng-container *ngIf="isViewMode">
                <div class="row" [ngClass]="isArabic ? 'rowReverse' : ''">
                    <div class="col-8 labelSection d-flex flex-column p-0 pb-3">
                        <label class="ques quesLabel" [ngClass]="isArabic ? 'rightAlign' : ''">
                            <span class="spanLabel">
                                <span *ngIf="!isArabic">Ticket Number : </span>
                                <span class="font-radikal-light">{{createdTicketNumber}}</span>
                                <span *ngIf="isArabic"> : رقم الطلب</span>
                            </span>
                        </label>
                        <label class="ques quesLabel" [ngClass]="isArabic ? 'rightAlign' : ''">
                            <span class="spanLabel">
                                <span *ngIf="!isArabic">Case Type : </span>
                                <span class="font-radikal-light">{{caseType}}</span>
                                <span *ngIf="isArabic">: نوع الطلب</span>
                            </span>
                        </label>
                    </div>
                    <div class="col-4 backBtn align-self-cente" [ngClass]="isArabic ? 'arabicAlign' : ''">
                        <button class="btn-lg btn-primary ratButton rightBtn" (click)="goToLastPage()">
                            <span *ngIf="!isArabic">back</span>
                            <span *ngIf="isArabic">العودة</span>
                        </button>
                    </div>
                </div>
            </ng-container>
            <div *ngIf="isIssueRaised" class="col-12">
                <alert type="success">
                    <p class="successAlert" [ngClass]="isArabic ? 'rightAlign' : ''">
                        <span *ngIf="!isArabic">Issue has been successfully raised. Ticket Number :
                            {{ticketNumber}}</span>
                        <span *ngIf="isArabic">{{ticketNumber}} :تم إنشاء الطلب بنجاح. رقم متابعة الطلب</span>
                    </p>
                </alert>
            </div>
            <div class="col-12 labelSection p-0" *ngIf="!isViewMode">
                <label class="mt-4 ques quesLabel mb-3" [ngClass]="isArabic ? 'rightAlign' : ''">
                    <span *ngIf="!isArabic">Provide the details of the issue :</span>
                    <span *ngIf="isArabic">: يرجى تقديم تفاصيل المشكلة:</span>
                </label>
            </div>
            <div class="bg-sky-blue">
                <div class="row border-top-form m-0" [ngClass]="isArabic ? 'arabicAlign' : ''">
                    <div class="col-12">
                        <div class="labelSection">
                            <label class="mt-4 ques quesLabel" [ngClass]="isArabic ? 'rightAlign' : ''">
                                <!-- <span *ngIf="!isArabic">Title of the Issue :</span>
                            <span *ngIf="isArabic">: عنوان الطلب</span> -->
                            </label>
                        </div>
                        <div class="ans-pnl">
                            <div class="inner1">
                                <div class="col-12 ratInput">
                                    <input type="text" class="form-control" formControlName="issueTitle" id="issueTitle"
                                        [placeholder]="isArabic ? ': عنوان الطلب' : 'Title of the Issue:'" required
                                        maxlength="3000" [ngClass]="isArabic ? 'rightAlign' : ''" />
                                </div>
                            </div>
                        </div>
                        <div *ngIf="reportIssueForm.controls['issueTitle']!.invalid" class="errMsg"
                            [ngClass]="isArabic ? 'rightAlign' : ''">
                            <span *ngIf="(isSubmitted || reportIssueForm.controls['issueTitle']!.touched || reportIssueForm.controls['issueTitle']!.dirty) && 
                    reportIssueForm.controls['issueTitle']!.errors!['required']">
                                <span *ngIf="!isArabic">This field is required</span>
                                <span *ngIf="isArabic">هذا الحقل مطلوب</span>
                            </span>
                        </div>
                        <!-- <div *ngIf="reportIssueForm.controls['issueTitle']!.valid" class="errMsg" [ngClass]="isArabic ? 'rightAlign' : ''">
                    <span *ngIf="(isSubmitted && isSlashTitle)">
                        <span *ngIf="!isArabic">; and \ are not allowed</span>
                        <span *ngIf="isArabic">؛ و \ غير مسموح بها</span>
                    </span>
                </div>  -->
                    </div>
                </div>
                <div class="row m-0" [ngClass]="isArabic ? 'arabicAlign' : ''">
                    <div class="col-12">
                        <div class="labelSection">
                            <label class="mt-4 ques quesLabel" [ngClass]="isArabic ? 'rightAlign' : ''">
                                <!-- <span *ngIf="!isArabic">Description :</span>
                            <span *ngIf="isArabic">: الوصف</span> -->
                            </label>
                        </div>
                        <div class="ans-pnl">
                            <div class="inner1">
                                <div class="col-12 ratInput">
                                    <textarea class="form-control" formControlName="issueDesc" id="issueDesc"
                                        [placeholder]="isArabic ? ':الوصف' : 'Description:'" required
                                        [ngClass]="isArabic ? 'rightAlign' : ''" maxlength="3000"></textarea>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="reportIssueForm.controls['issueDesc']!.invalid" class="errMsg"
                            [ngClass]="isArabic ? 'rightAlign' : ''">
                            <span *ngIf="(isSubmitted || reportIssueForm.controls['issueDesc']!.touched || reportIssueForm.controls['issueDesc']!.dirty) && 
                    reportIssueForm.controls['issueDesc']!.errors!['required']">
                                <span *ngIf="!isArabic">This field is required</span>
                                <span *ngIf="isArabic">هذا الحقل مطلوب</span>
                            </span>
                        </div>
                        <!-- <div *ngIf="reportIssueForm.controls['issueDesc']!.valid" class="errMsg" [ngClass]="isArabic ? 'rightAlign' : ''">
                    <span *ngIf="(isSubmitted && isSlashDesc)">
                        <span *ngIf="!isArabic">; and \ are not allowed</span>
                        <span *ngIf="isArabic">؛ و \ غير مسموح بها</span>
                    </span>
                </div>  -->
                    </div>
                </div>
                <div class="row  border-bottom-form m-0" [ngClass]="isArabic ? 'arabicAlign' : ''">
                    <div class="col-12">
                        <div class="labelSection">
                            <label class="mt-4 ques quesLabel" [ngClass]="isArabic ? 'rightAlign' : ''">
                                <span *ngIf="!isArabic">Attachment :</span>
                                <span *ngIf="isArabic">: المرفقات</span>
                            </label>
                        </div>
                        <ng-container *ngIf="!isViewMode">
                            <div class="ans-pnl">
                                <div class="inner1White" [ngClass]="isArabic ? 'rightAlign' : ''"
                                    [style.text-align]="isArabic ? 'right' : 'left'">
                                    <input type="file" #attachment name="notesName"
                                        class="reportIssueFile font-radikal-light" (change)="handleFileInput($event)"
                                        required [attr.dir]="isArabic ? 'rtl' : 'ltr'"
                                        [style.text-align]="isArabic ? 'right' : 'left'" />
                                </div>
                            </div>
                            <div [ngClass]="isArabic ? 'rightAlign' : ''">
                                <ng-container *ngIf="isSubmitted && isFileUploaded == undefined">
                                    <span class="sizeErr">
                                        <span *ngIf="!isArabic" class="errMsg">Please upload a file</span>
                                        <span *ngIf="isArabic" class="errMsg">يرجى رفع ملف</span>
                                    </span>
                                </ng-container>
                                <ng-container *ngIf="isFileUploaded !== undefined">
                                    <span *ngIf="fileTypeErr" class="sizeErr">
                                        <span *ngIf="!isArabic" class="errMsg">Please select file having extensions
                                            .doc/.docx/.pdf/.txt only.</span>
                                        <span *ngIf="isArabic" class="errMsg">يرجى اختيار ملف بالامتدادات التالية فقط
                                            .doc/ .docx / .pdf / .txt فقط.</span>
                                    </span>
                                    <span *ngIf="showSizeErr" class="sizeErr">
                                        <span *ngIf="!isArabic" class="errMsg">File size exceeded 20Mb</span>
                                        <span *ngIf="isArabic" class="errMsg">20Mb حجم الملف تجاوز</span>
                                    </span>
                                    <span *ngIf="fileUploadErr" class="sizeErr">
                                        <span *ngIf="!isArabic" class="errMsg">File has not been uploaded</span>
                                        <span *ngIf="isArabic" class="errMsg">لم يتم تحميل الملف</span>
                                    </span>
                                </ng-container>
                            </div>
                            <div class="noteGuidance" [ngClass]="isArabic ? 'rightAlign' : ''">
                                <span *ngIf="isArabic">
                                    * يمكنك اختيار ملف واحد بحد أقصى حجم 20 ميجابايت. سيتم تحميل الملف بعد النقر على زر
                                    "إرسال".
                                </span>
                                <span *ngIf="!isArabic">
                                    * You can select a maximum of 1 file with a maximum size of 20MB. The file will be
                                    uploaded once you click "Submit".
                                </span>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="isViewMode">
                            <div class="ans-pnl">
                                <div class="inner1White" [ngClass]="isArabic ? 'rightAlign' : ''">
                                    <div class="urlDiv" [ngClass]="isArabic ? 'rightAlign' : ''">
                                        <span class="font-radikal-light">{{uploadedFileName}}</span>
                                        <!-- <a class="dwnld" (click)="handleFileLinkClick()">
                                        <span *ngIf="!isArabic">Download</span>
                                        <span *ngIf="isArabic">تحميل</span>
                                    </a> -->
                                    </div>
                                </div>
                            </div>

                        </ng-container>
                    </div>
                    <div class="col-12 mt-4 text-end mb-5 submitBtnDiv" *ngIf="!isViewMode">
                        <button type="button" class="btn btn-lg btn-primary submitBtn" type="submit"
                            (click)="reportIssue()" [disabled]="disabledBtn">
                            <span *ngIf="!isArabic">Submit</span><span *ngIf="isArabic">إرسال</span></button>
                    </div>
                </div>
                <!-- resolution comment -->
                <div *ngIf="isViewMode" class="row" [ngClass]="isArabic ? 'arabicAlign' : ''">
                    <div class="col-12 px-4 pb-4">
                        <div class="labelSection">
                            <label class="mt-4 ques quesLabel" [ngClass]="isArabic ? 'rightAlign' : ''">
                                <span *ngIf="!isArabic">Resolution Comment :</span>
                                <span *ngIf="isArabic">: تعليقات القرار</span>
                            </label>
                        </div>
                        <ng-container *ngIf="comments">
                            <div class="ans-pnl">
                                <div class="inner1">
                                    <div class="col-12 ratInput">
                                        <textarea class="form-control font-radikal-light"
                                            formControlName="resolutionComment" id="resolutionComment"
                                            [placeholder]="isArabic ? 'لا توجد تعليقات متاحة' : 'No comments available' "
                                            [ngClass]="isArabic ? 'rightAlign' : ''" maxlength="3000"></textarea>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="!comments">
                            <div class="no-comments font-radikal-light" [ngClass]="isArabic ? 'rightAlign' : ''">
                                {{isArabic ? 'لا توجد تعليقات متاحة' : 'No comments available'}}
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="serverErr">
                <div class="offset-8 col-4">
                    <div class="errMsg serverErr">
                        <span>{{serverErr}}</span>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>